import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconCode32(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={32}
            className={customClassName}
            name="IconCode32"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M19.01 10.65a1 1 0 1 0-1.868-.717l-4.3 11.203a1 1 0 1 0 1.867.717zm-7.96 11.714a1 1 0 0 1-1.414 0L3.98 16.707 3.272 16l.708-.707 5.656-5.657a1 1 0 1 1 1.415 1.414L6.1 16l4.95 4.95a1 1 0 0 1 0 1.414m9.9-12.728a1 1 0 0 1 1.414 0l5.657 5.657.707.707-.707.707-5.657 5.657a1 1 0 0 1-1.414-1.414L25.9 16l-4.95-4.95a1 1 0 0 1 0-1.414"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconCode32);
